<template>
	<Modal
		v-if="showCoachingModal"
		:max-width="'max-w-[480px]'"
		:hide-actions="true"
		:allow-close="false"
		:remove-padding="true"
		rounded-size="rounded-[20px]"
		:prevent-scrolling="false"
		@modal:close="onMaybeLater"
	>
		<template #body>
			<div class="relative">
				<FirstApplicationPaywallHeader />
				<button
					type="button"
					class="absolute top-3 right-3 rounded-full p-1 hover:bg-black/5"
					aria-label="Close"
					@click="onMaybeLater"
				>
					<XMarkIcon class="size-6 text-won-dark-blue" />
				</button>
			</div>

			<div class="px-6 pt-5 pb-6 font-[Inter] text-won-blue">
				<p class="text-center text-xs font-medium text-won-green">
					Get to a Real Offer Faster
				</p>
				<h2 class="mt-1 text-center text-[22px] leading-tight font-bold">
					Not ready to upgrade? Let's talk first.
				</h2>
				<p class="mt-2 text-center text-sm text-won-dark-blue">
					Our coaches have helped 2,500+ people land real offers. Before you decide anything, book a free 30-minute call and figure out whether coaching's even worth it for you.
				</p>

				<hr class="mt-5 border-won-green" />

				<div class="mt-5 rounded-xl bg-won-green-hover p-4">
					<p class="text-sm font-bold">
						What we'll cover on your free 1:1
					</p>
					<ul class="mt-2 list-disc space-y-1 pl-5 text-sm text-won-dark-blue marker:text-won-dark-blue">
						<li
							v-for="point in coveragePoints"
							:key="point"
						>
							{{ point }}
						</li>
					</ul>
				</div>

				<div class="mt-6 flex flex-col gap-2">
					<button
						type="button"
						class="h-10 w-full cursor-pointer rounded-md bg-won-green text-sm font-semibold text-white hover:bg-won-green/90"
						@click="onBookCall"
					>
						Book Your Free Call
					</button>
					<button
						type="button"
						class="h-10 w-full cursor-pointer rounded-md bg-[#F1F1F1] text-sm font-semibold text-won-dark-blue hover:bg-[#E9E9E9]"
						@click="onMaybeLater"
					>
						Maybe Later
					</button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import { XMarkIcon } from '@heroicons/vue/24/outline';

import Modal from '../../components/modal.vue';
import FirstApplicationPaywallHeader from '../../icons/first-application-paywall-header.vue';
import { useOnboardingRetentionStore } from '../../store/onboarding-retention.store';
import { trackNudge } from '../../api/nudge.js';
import { CALENDLY_BILLING_URL } from '../../utils/constants';
import { openLink } from '../../utils/helpers';

const coveragePoints = [
	'Where your search is actually getting stuck',
	'How our team lands people offers in 120 days',
	'Whether coaching could help - a straight answer, no pressure',
];

const retentionStore = useOnboardingRetentionStore();
const { showCoachingModal } = storeToRefs(retentionStore);

const onBookCall = () => {
	trackNudge({ feature: 'auto_apply', event: 'cta_clicked' });
	openLink(CALENDLY_BILLING_URL, true);
	retentionStore.dismissCoachingModal();
};

const onMaybeLater = () => retentionStore.dismissCoachingModal();
</script>
